import React, { useEffect, useState } from "react";
import "./PaymentSuccess.css";

export default function PaymentSuccess() {

  const [pedido,setPedido] = useState(null);

  const SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycbzRpTEbdM6dzZwK7v_48aEJjNVivn-auestSaWDHNebj8kI73yW2CE9aZMihb8Wt-_g/exec";

  useEffect(()=>{

    const params = new URLSearchParams(window.location.search);

    const pedido_id = params.get("external_reference");
    const status = params.get("status");

    setPedido(pedido_id);

    if(!pedido_id) return;

    fetch(SCRIPT_URL,{
      method:"POST",
      body:new URLSearchParams({
        pedido_id:pedido_id,
        status:status || "approved"
      })
    });

  },[]);


  return(

    <div className="payment-page">

      <div className="payment-card">

        <div className="icon-sc">
          ✓
        </div>

        <h1>Pagamento aprovado!</h1>

        <p>
          Seu pedido foi confirmado com sucesso.
        </p>

        {pedido && (
          <p className="pedido">
            Pedido: <strong>{pedido}</strong>
          </p>
        )}

        <p className="ok">
          Pedido registrado com sucesso.
        </p>

        <button
          className="btn"
          onClick={()=>window.location.href="/"}
        >
          Voltar ao site
        </button>

      </div>

    </div>

  )

}